import SLPPerFuel from './SLPPerFuel';

export default SLPPerFuel;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/slpPerFuel/index.js